/*=========================================================================================
  File Name: moduleScheduleMutations.js
  Description: Schedule Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_EVENT(state, event) {
		state.eventsTimeWindow.push(event);
	},
	UPDATE_TIME_WINDOW(state, item) {
		const timeWindowIndex = state.timeWindowList.findIndex((p) => p.id === item.id);
		if (timeWindowIndex !== -1) {
			Object.assign(state.timeWindowList[timeWindowIndex], item);
		}
	},
	SET_SCHEDULE_EVENTS_TIME_WINDOW(state, events) {
		if (events.length > 0 && events[0] !== "invalid cron expression") {
			state.eventsTimeWindow = events[0].map((e) => {
				return {...e, calendarId: e.init_hour_window};
			});
		}
	},
	SET_SCHEDULE_LABELS_STATUS(state, labels) {
		state.eventSatusLabels = labels;
	},
	UPDATE_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
		Object.assign(state.events[eventIndex], {
			...event,
			calendarId: event.init_hour + event.event_id,
			status_id: 5,
		});
	},
	REMOVE_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
		state.events.splice(eventIndex, 1);
	},
	CLEAN_EVENTS(state) {
		state.events = [];
	},
	SET_TIME_WINDOW(state, items) {
		state.timeWindowList = [...items];
	},
	REMOVE_TIME_WINDOW(state, itemId) {
		const ItemIndex = state.timeWindowList.findIndex((p) => p.id === itemId);
		state.timeWindowList.splice(ItemIndex, 1);
	},
	SET_CRON_EXPRESSION(state, item) {
		state.cronExpression = item;
	},
	SET_ASSIGNED_TIME_WINDOW(state, items) {
		let arrayNew = state.assignedTimeWindows.concat(
			items.filter((element) => state.assignedTimeWindows.find((e) => e.id === element.id) === undefined)
		);
		state.assignedTimeWindows = arrayNew;
	},
	REMOVE_ASSIGNED_TIME_WINDOW(state, itemId) {
		const ItemIndex = state.assignedTimeWindows.findIndex((p) => p.id === itemId);
		state.assignedTimeWindows.splice(ItemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_TIME_WINDOW(state) {
		state.assignedTimeWindows = [];
	},
	ADD_TIME_WINDOW_CHECKED(state, item) {
		const itemIndex = state.checkedTimeWindows.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedTimeWindows.push(item);
		}
	},
	SET_TIME_WINDOW_CHECKED(state, items) {
		state.checkedTimeWindows = [...items];
	},
	REMOVE_TIME_WINDOW_CHECKED(state, item) {
		const itemIndex = state.checkedTimeWindows.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedTimeWindows.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_TIME_WINDOW_CHECKED(state) {
		state.checkedTimeWindows = [];
	},
};
